import {FC} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {isFinance} from 'shared/lib/isFinance';
import RocketworkFinanceLogo from 'shared/assets/svg/rocketwork-finance-logo.svg?react';
import RocketworkLogo from 'shared/assets/svg/rocketwork-logo.svg?react';

export const AppLogo: FC<{className?: string; to: string}> = ({className, to}) => {
	const finance = isFinance();
	const Logo = finance ? RocketworkFinanceLogo : RocketworkLogo;
	const vendorName = finance ? 'Рокет Ворк Финанс' : 'Рокет Ворк';

	return (
		<Link to={to} className={cn('relative block h-full', className)}>
			<Logo className="h-full w-auto max-w-full object-contain" role="img" aria-label={vendorName} />
		</Link>
	);
};
